var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-profile"},[_c('div',[_c('Avatar',{attrs:{"icon":"pi pi-user","size":"large","shape":"circle"}})],1),_c('span',{staticClass:"username",staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.token_name || ""))])])
}
var staticRenderFns = []

export { render, staticRenderFns }